import { useEffect, useState } from "react";
import { Sparkles, X } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

function PackageButton({ pkg, disabled, onPick }) {
  return (
    <button
      data-testid={`promote-pkg-${pkg.id}`}
      disabled={disabled}
      onClick={() => onPick(pkg.id)}
      className="w-full border-2 border-black p-4 text-left hover:bg-yellow-100 disabled:opacity-50 flex items-center justify-between"
    >
      <div>
        <div className="font-display text-xl uppercase">{pkg.label}</div>
        <div className="font-mono-data text-xs uppercase text-gray-600">{pkg.days} days · top placement · featured badge</div>
      </div>
      <div className="font-mono-data text-3xl font-bold">${pkg.amount}</div>
    </button>
  );
}

export function PromoteModal({ listingId, onClose }) {
  const [packages, setPackages] = useState([]);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/promote/packages").then(({ data }) => setPackages(data));
  }, []);

  const close = () => { if (!busy) onClose(); };

  const startCheckout = async (packageId) => {
    setBusy(true);
    try {
      const { data } = await api.post(`/listings/${listingId}/promote`, { package_id: packageId, origin_url: window.location.origin });
      window.location.href = data.url;
    } catch (e) {
      toast.error("Could not start checkout: " + (e.response?.data?.detail || e.message));
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4" data-testid="promote-modal" onClick={close}>
      <div className="bg-white border-2 border-black hard-shadow max-w-[480px] w-full" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between border-b-2 border-black p-4">
          <h3 className="font-display text-2xl uppercase flex items-center gap-2"><Sparkles size={20} className="text-[#0000EE]" /> Promote Listing</h3>
          <button data-testid="promote-modal-close" onClick={close} className="border-2 border-black p-1 hover:bg-black hover:text-white"><X size={14} /></button>
        </div>
        <div className="p-5 space-y-3">
          <p className="font-mono-data text-xs uppercase text-gray-700">Boost your ad to the top of category & home pages with a ★ FEATURED badge.</p>
          {packages.map((p) => <PackageButton key={p.id} pkg={p} disabled={busy} onPick={startCheckout} />)}
          <p className="font-mono-data text-[10px] uppercase text-gray-500">Secure checkout via Stripe. Test mode — use card 4242 4242 4242 4242.</p>
        </div>
      </div>
    </div>
  );
}
